import instance from "../core/instance";

/**
 * Leaderboard API. The token is attached by the shared axios instance's
 * interceptor, so posting a score just needs the player to be signed in.
 */

export type LeaderboardPeriod = "week" | "all";

export interface LeaderboardEntry {
  rank: number;
  alias: string;
  score: number;
  bestSpan: number;
  achievedAt: string;
}

export interface SubmitScorePayload {
  game: string;
  /** What the player wants shown publicly — never their real name unless
   *  they type it. */
  alias: string;
  score: number;
  bestSpan: number;
  rounds: number;
}

export interface SubmitScoreResponse {
  id: number;
  game: string;
  alias: string;
  score: number;
  bestSpan: number;
  rounds: number;
  achievedAt: string;
  weeklyRank: number | null;
}

const GamesService = {
  leaderboard: async (params: {
    game: string;
    period: LeaderboardPeriod;
    limit?: number;
  }): Promise<LeaderboardEntry[]> => {
    const { data } = await instance.get<LeaderboardEntry[]>(
      "/games/leaderboard",
      { params },
    );
    return data;
  },

  submitScore: async (
    payload: SubmitScorePayload,
  ): Promise<SubmitScoreResponse> => {
    const { data } = await instance.post<SubmitScoreResponse>(
      "/games/scores",
      payload,
    );
    return data;
  },

  myRank: async (params: {
    game: string;
    period: LeaderboardPeriod;
  }): Promise<{ game: string; period: LeaderboardPeriod; rank: number | null }> => {
    const { data } = await instance.get("/games/leaderboard/me", { params });
    return data;
  },
};

export default GamesService;
